import { vueErrorHandler } from "./vue-error-handler.ts";

function unreachableCaseError(value: never): Error {
  let formattedValue: string;
  try {
    formattedValue = JSON.stringify(value) ?? String(value);
  } catch {
    formattedValue = String(value);
  }
  return new Error(`Unreachable case: ${formattedValue}`);
}

/** Enforces exhaustive handling for values controlled by this UI. */
export function throwUnreachableCase(value: never): never {
  throw unreachableCaseError(value);
}

/**
 * Enforces exhaustive handling for wire values while preserving compatibility
 * with a newer backend by reporting an unknown value and returning a fallback.
 */
export function reportUnreachableCase<T>(value: never, fallback: T): T {
  vueErrorHandler(
    unreachableCaseError(value),
    null,
    "Unexpected value received from the backend",
  );
  return fallback;
}
